import styled, {keyframes} from 'styled-components';

const slideUp = keyframes`
	from {
		transform: translateY(100%);
	}
	to {
		transform: translateY(0);
	}
`;

export const Overlay = styled.div`
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 10001;
	overflow: hidden;
	touch-action: none;
`;

export const Sheet = styled.div`
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 10000;

	background: #f2f2f2;
	display: flex;
	flex-direction: column;

	animation: ${slideUp} 0.25s ease-out;
`;

export const Header = styled.div`
	min-height: 56px;

	display: flex;
	align-items: center;

	padding: 0 20px;
	border-bottom: 1px solid #eaeaea;
`;

export const HeaderSection = styled.div`
	flex: 1;
`;

export const CloseButton = styled.button`
	border: none;
	background: transparent;
	font-size: 22px;
	cursor: pointer;
`;

export const Content = styled.div`
	flex: 1;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
`;
